<template>
  <v-card class="mt-5">
    <AppVCardTitle label="Sécurité"/>

    <AppRadioYesNoBoolean v-model="value.hasScamLadder" label="Echelle harnachée *"
                          image_url="/img/implementedForms/62b97ed722d02/scamLadder.png"></AppRadioYesNoBoolean>
    <v-card-text class="pt-0 pb-0">
      <v-textarea v-if="!value.hasScamLadder" v-model="value.commentScamLadder" placeholder="Commentaire" filled
                  auto-grow rows="1"/>
    </v-card-text>
    <AppRadioYesNoBoolean v-model="value.hasHarnessWithLifeLine"
                          label="Baudrier avec ligne de vie *"></AppRadioYesNoBoolean>
    <v-card-text class="pt-0 pb-0">
      <v-textarea v-if="!value.hasHarnessWithLifeLine" v-model="value.commentHarnessWithLifeLine"
                  placeholder="Commentaire" class=" v-textarea" filled auto-grow rows="1"></v-textarea>
    </v-card-text>
    <v-card-text>
      <v-checkbox v-model="value.hasPersonalProtectiveEquipment" class="mt-n4"
                  label="EPI : Chaussures de sécurité, casque, lunettes, gants et vêtements à bandes réfléchissantes *"
                  :rules="[v => v]"/>
    </v-card-text>
  </v-card>
</template>

<script>
import AppVCardTitle from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/VCardTitle";
import AppRadioYesNoBoolean
  from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/RadioYesNoBoolean.vue";

export default {
  name: "PreventivePlan",
  components: {
    AppRadioYesNoBoolean,
    AppVCardTitle,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>